import WFLink from '../WFLink'
import * as WFC from '../WFConstants'

/**
 * Created by Xuz on 2020/01/20.
 * xuz@live.cn
 * 连接线
 */
class TBLinker {
  constructor (workflow) {
    this.workflow = workflow
    this.$_c = this.workflow.parent.$_c
    this._linker = null
  }

  doMouseDown (event) {
    let el = this.workflow.getSelectedElement(event)
    if (el == null) {
      this.workflow.setUnSelectLastElement(event)
    } else {
      this.workflow.setActiveElement(el, event)
    }
  }

  doMouseMove (event) {
    let el = this.workflow.getLastElement(event)
    if (this._linker == null) {
      // 结点不能画出发线 */
      if (el.getType() === WFC.NODE_TYPE_END_NODE) {
        this.workflow.setMessage('activity.notlinkable')
        return
      } else if (el.getType() === WFC.NODE_TYPE_START_NODE) {
        let startNodeLinkers = this.workflow.getNodeRoads(el.uuid())
        // 如果是起点，但已经有一条出发线就不允许再画
        if (startNodeLinkers != null) {
          for (let i in startNodeLinkers) {
            if (startNodeLinkers[i] != null) {
              this.workflow.setMessage('startnode.onlyone.allow')
              return
            }
          }
        }
      }
      this._linker = new WFLink(this.workflow)
      this._linker.create(event, el)
    }
    this._linker.onMove(event)
  }

  doMouseUp (event) {
    if (this._linker == null) {
      return
    }
    this._linker.onUp(event)
    this._linker = null
  }

  doMouseDblClick (event) {
    const el = this.workflow.getSelectedElement(event)
    if (el == null) {
      this.workflow.setUnSelectLastElement(event)
    } else {
      if (el === this.workflow.getLastElement()) {
        el.onMouseDblClick(event)
      } else {
        this.workflow.setActiveElement(el, event)
      }
    }
  }

  getName () {
    return '连线'
  }

  getIcon () {
    return this.$_c + 'app/workflow/img/design/linker.png'
  }
}

export default TBLinker
